import { TableFieldModel } from '@/model/TableList'
import { numberTimes, priceWithoutRate, totalPriceWithoutRate } from '@/utils/index'
import $currency from 'currency.js'

export const TableField: TableFieldModel[] = [
  {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'titleName',
    fieldName: '所属公司'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceDate',
    fieldName: '开票时间',
    convert: ({ rowData }) => rowData.invoiceDetails?.map((item: any) => item.date).join('，')
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'invoiceNo',
    fieldName: '发票号码',
    convert: ({ rowData }) => rowData.invoiceDetails?.map((item: any) => item.no).join('，')
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'no',
    fieldName: '业务编号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessClass',
    fieldName: '业务类型'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'salesMan',
    fieldName: '业务代表',
    width: 120
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'engineers',
    fieldName: '工程师',
    convert: ({ rowData }) => rowData.engineers?.join(',')
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'companyName',
    fieldName: '公司名称',
    convert: ({ rowData }) => rowData.customerCompany?.name
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'brand',
    fieldName: '业务品牌',
    width: 100
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'name',
    fieldName: '业务名称'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'model',
    fieldName: '型号'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'amount',
    fieldName: '数量',
    width: 80
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFee',
    fieldName: '单价含税',
    isMoney: true,
    textAlign: 'right',
    width: 120
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFeeTotal',
    fieldName: '总价含税',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData
      if (!orderFee) {
        return ''
      }
      const { amount } = rowData
      return numberTimes(orderFee, amount, true)
    }
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderFeeTotalAfterTax',
    fieldName: '总价税后',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { orderFee } = rowData
      if (!orderFee) {
        return ''
      }
      const {
        amount,
        orderTaxRate
      } = rowData
      return totalPriceWithoutRate(orderFee, amount, true, orderTaxRate)
    }
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'orderTaxRate',
    fieldName: '税率',
    formatType: 'percent',
    width: 60
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'outCost',
    fieldName: '外包费成本（税后）',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { outCost } = rowData
      if (!outCost) {
        return ''
      }
      // const { outTaxFee } = rowData
      // const outCostWithTaxFee = outCost - (outTaxFee ?? 0)
      return $currency(outCost)
    }
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'partsCost',
    fieldName: '出库总成本（税后）',
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { partsCost } = rowData
      if (!partsCost) {
        return ''
      }
      // const { partsTaxFee } = rowData
      // const partsCostWithTaxFee = partsCost - (partsTaxFee ?? 0)
      return $currency(partsCost)
    }
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'marketCost',
    fieldName: '市场费成本（税后）',
    isMoney: true,
    textAlign: 'right',
    width: 120,
    convert: context => {
      const { rowData } = context
      const { marketCost } = rowData
      if (!marketCost) {
        return ''
      }
      const { marketTaxFee } = rowData
      return priceWithoutRate(marketCost, true, marketTaxFee)
    }
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'customerOrderNo',
    fieldName: '订单号码'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'contacts',
    fieldName: '联系人',
    convert: ({ rowData }) => rowData.contacts?.join(',')
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'businessClass',
    fieldName: '业务分类'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'outsourceCompanyName',
    fieldName: '外包商'
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'repairTimes',
    fieldName: '返修次数',
    width: 120
  }, {
    componentType: 'el-input',
    componentName: '输入框',
    fieldKey: 'fault',
    fieldName: '故障描述'
  }
]
